// Sample story for landing page demo: "Luna Learns to Breathe"
// A mindfulness story about a young fox who learns to manage anxiety

export const sampleStory = {
  title: "Luna Learns to Breathe",
  coverImageUrl: "/landing/samples/luna-cover.png",
  mainCharacter: {
    name: "Luna",
    avatarUrl: "/landing/samples/luna-avatar.png",
  },
  pages: [
    {
      text: "Luna the little fox felt her heart racing as she looked at the tall mountain ahead. The path seemed so steep and the clouds at the top looked so far away. \"I can't do this,\" she whispered, her paws trembling.",
      imageUrl: "/landing/samples/luna-page-1.png",
    },
    {
      text: "Her wise grandmother placed a gentle paw on her shoulder. \"I see you're feeling worried, little one,\" Grandmother Fox said softly. \"Let me teach you something special that has helped me climb many mountains.\"",
      imageUrl: "/landing/samples/luna-page-2.png",
    },
    {
      text: "\"Close your eyes,\" Grandmother whispered. \"Now breathe in slowly... one... two... three. Feel your belly fill up like a balloon. Then let it out gently... one... two... three... four... five.\"",
      imageUrl: "/landing/samples/luna-page-3.png",
    },
    {
      text: "Luna practiced the breathing, in and out, in and out. With each breath, she felt the worry melt away like morning frost in sunshine. Her racing heart began to slow, and a warm feeling spread through her chest.",
      imageUrl: "/landing/samples/luna-page-4.png",
    },
    {
      text: "Luna opened her eyes and smiled. The mountain didn't seem quite so scary anymore. She took her first step up the path, knowing that whenever she felt afraid, she could always remember to breathe. And that made all the difference.",
      imageUrl: "/landing/samples/luna-page-5.png",
    },
  ],
};

// Voice samples data for the landing page.
// TODO: the .mp3 files under public/landing/audio/ were generated by Hume Octave.
// After running scripts/generate-voice-samples.js (now powered by Gemini 3.1 Flash TTS),
// the output filenames will be .wav — update the audioUrl values below to match.
export const voiceSamples = [
  {
    id: 'alloy',
    name: 'Alloy',
    gender: 'Female',
    description: 'Clear and versatile',
    audioUrl: '/landing/audio/alloy-sample.mp3',
    color: '#E8907A', // coral
  },
  {
    id: 'echo',
    name: 'Echo',
    gender: 'Male',
    description: 'Resonant and engaging',
    audioUrl: '/landing/audio/echo-sample.mp3',
    color: '#7DB896', // sage
  },
  {
    id: 'fable',
    name: 'Fable',
    gender: 'Female',
    description: 'Warm storyteller',
    audioUrl: '/landing/audio/fable-sample.mp3',
    color: '#A890C7', // lavender
  },
  {
    id: 'onyx',
    name: 'Onyx',
    gender: 'Male',
    description: 'Deep and authoritative',
    audioUrl: '/landing/audio/onyx-sample.mp3',
    color: '#5B6BB0', // indigo
  },
  {
    id: 'nova',
    name: 'Nova',
    gender: 'Female',
    description: 'Bright and energetic',
    audioUrl: '/landing/audio/nova-sample.mp3',
    color: '#E8A849', // amber
  },
  {
    id: 'shimmer',
    name: 'Shimmer',
    gender: 'Male',
    description: 'Smooth and gentle',
    audioUrl: '/landing/audio/shimmer-sample.mp3',
    color: '#6DBAB0', // teal
  },
];

// Character traits for the teaser animation
export const sampleCharacterTraits = {
  personality: ['Brave', 'Curious', 'Kind', 'Creative', 'Playful'],
  fears: ['Thunder', 'The Dark', 'Being Alone', 'Loud Noises'],
  dreams: ['Flying', 'Being a Hero', 'Making Friends', 'Adventures'],
  likes: ['Stargazing', 'Warm Hugs', 'Bedtime Stories', 'Butterflies'],
};

// Wizard steps data
export const wizardSteps = [
  {
    number: 1,
    title: 'Choose Hero',
    description: 'Select or create your main character with deep customization',
    icon: 'User',
    details: [
      'Pick from saved characters or create new',
      'Add personality traits, fears, and dreams',
      'Give them special abilities and backstory',
    ],
  },
  {
    number: 2,
    title: 'Add Friends',
    description: 'Include supporting characters to join the adventure',
    icon: 'Users',
    details: [
      'Add companions or sidekicks',
      'Include family members or pets',
      'Create meaningful relationships',
    ],
  },
  {
    number: 3,
    title: 'Story Details',
    description: 'Choose themes, settings, and storytelling style',
    icon: 'BookOpen',
    details: [
      'Select emotional themes like courage or kindness',
      'Pick magical settings like forests or castles',
      'Choose story length and complexity',
    ],
  },
  {
    number: 4,
    title: 'Art Style',
    description: 'Pick how your illustrations will look',
    icon: 'Palette',
    details: [
      'Choose from multiple AI art models',
      'Watercolor, cartoon, or realistic styles',
      'Consistent character appearance',
    ],
  },
  {
    number: 5,
    title: 'Voice Options',
    description: 'Select narration voice for audio playback',
    icon: 'Headphones',
    details: [
      '6 unique AI voices to choose from',
      'Preview each voice before selecting',
      'Perfect for bedtime listening',
    ],
  },
  {
    number: 6,
    title: 'Create!',
    description: 'Review and generate your personalized story',
    icon: 'Sparkles',
    details: [
      'Review all your choices',
      'AI generates unique story text',
      'Illustrations created for each page',
    ],
  },
];
